import React from 'react';
import { Helmet } from 'react-helmet-async';
import manikchandLogo from '../../assets/images/manikchand_Logo.svg';

const BecomePartnerPageHelmet: React.FC = () => {
  return (
    <>
      <Helmet>
        {/*Title & Meta Description*/}
        <title>Partner with Manikchand</title>
        <meta
          name='description'
          content='Join Namasteji Manikchand as a trusted partner. Order Manikchand products, explore premium pan masala flavors, and grow with the best pan masala brand in India.'
        />
        <meta
          name='keywords'
          content='Namasteji Manikchand dealership contact number,
          Namasteji Manikchand distributor registration,
          Become Namasteji Manikchand pan masala partner,
          Namasteji Manikchand  pan masala  dealership apply online,
          Manikchand business partnership opportunities,
          Namasteji Manikchand franchise enquiry'
        />
        {/* <meta name='robots' content='index, follow' /> */}
        <link rel='canonical' href='https://globalmanikchand.in/partner' />

        {/* Open Graph (OG)Share for Facebook, LinkedIn  */}
        <meta property='og:title' content='Join Manikchand Network' />
        <meta
          property='og:description'
          content='Become a Namasteji Manikchand partner. Buy premium pan masala online and collaborate with India’s leading brand.'
        />
        <meta property='og:image' content={window.location.origin + manikchandLogo} />
        <meta property='og:url' content='https://globalmanikchand.in/partner' />
        <meta property='og:type' content='website' />
        <meta property='og:site_name' content='Namasteji Manikchand partner' />
        <meta property='og:locale' content='en_IN' />

        {/* Twitter Card */}
        <meta name='twitter:card' content={window.location.origin + manikchandLogo} />
        <meta name='twitter:title' content='Join Manikchand Network' />
        <meta
          name='twitter:description'
          content='Become a Namasteji Manikchand partner. Buy premium pan masala online and collaborate with India’s leading brand.'
        />
        <meta name='twitter:image' content={window.location.origin + manikchandLogo} />
        <meta name='twitter:site' content='@NamastejiManikchand' />

        {/* Structured Data (Schema.org JSON-LD)  */}
        {/* <script type='application/ld+json'>{`
          {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Become Partner – Namasteji Manikchand",
            "url": "https://globalmanikchand.in/partner",
            "description": "Join Namasteji Manikchand as an official distributor or business partner to grow your business with a trusted Pan Masala legacy.",
            "publisher": {
              "@type": "Organization",
              "name": "Namasteji Manikchand",
              "logo": {
                "@type": "ImageObject",
                "url": "https://globalmanikchand.in/logo_icon.svg"
              }
            }
          }
        `}</script> */}
      </Helmet>
    </>
  );
};

export default BecomePartnerPageHelmet;
